"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CollectionHeading_1 = __importDefault(require("./CollectionHeading"));
exports.default = CollectionHeading_1.default;
